import GaEvent from './GaEvent';

export default class ContactFormSubmittedGaEvent extends GaEvent {
  constructor() {
    super('contact_form_submitted');
  }
}
